import { Component } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_side_modal_direction_define_component',
    templateUrl: './c_side_modal_direction_define.component.html',
    styleUrls: ['../../common.scss', '../../c_side_modal.component.scss'],
    standalone: false
})
export class c_side_modal_direction_define_component extends BaseComponent {

  constructor() { super(); }
}
